import React, { useState, useRef, useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"

import { css } from "@emotion/react"

const Cloud = ({
  filename,
  top,
  right,
  bottom,
  left,
  imgWidth,
}) => {
  const [ animate, setAnimate ] = useState(false)

  const target = useRef(null)

  const { allFile } = useStaticQuery(graphql`
    query {
      allFile(filter: {name: {regex: "/cloud_/"}}, sort: {fields: name}) {
        edges {
          node {
            id
            publicURL
          }
        }
      }
    }
  `)

  useEffect(() => {
    const callback = (entries) => {
      entries.forEach((entry) => {
        if ( entry.isIntersecting ) {
          setAnimate(true)
        }
      })
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    }

    const observer = new IntersectionObserver(callback, options)

    observer.observe(target.current)

    const unsubscribe = () => observer.disconnect(target.current)

    return () => unsubscribe()
  }, [])

  const style = {
    wrapper: css`
      padding: ${ left !== '' ? '0 ' + left.replace('-', '') + ' 0 0' : '0 0 0 ' + right.replace('-', '') };
      position: absolute;
      top: ${ top };
      right: ${ right };
      bottom: ${ bottom };
      left: ${ left };
      transform: translateX( ${ left !== '' ? '-50%' : '50%' } );
      opacity: 0;
      ${ animate && 'animation: slideIn 3s ease forwards' };
      @keyframes slideIn {
        80% {
          opacity: 1;
        }
        100% {
          opacity: 1;
          transform: translateX( 0% )
        }
      }
    `,
  }

  return (
    <div
      ref={ target }
      css={ style.wrapper }
    >
      { allFile.edges.map(item => (
        item.node.publicURL.indexOf(filename) !== -1 &&
        <img
          key={ item.node.id }
          src={ item.node.publicURL }
          width={ imgWidth }
          alt=""
        />
      ))}
    </div>
  )
}

export default Cloud

Cloud.propTypes = {
  filename: PropTypes.string.isRequired,
  top: PropTypes.string,
  right: PropTypes.string,
  bottom: PropTypes.string,
  left: PropTypes.string,
  imgWidth: PropTypes.string
}

Cloud.defaultProps = {
  top: ``,
  right: ``,
  bottom: ``,
  left: ``,
  imgWidth: ``,
}